import { get, orderBy } from 'lodash';
import { custom } from '../../utils/Api';
import {
  FETCH_DETAIL_APPROVAL_REQUESTS,
  FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE,
  FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS,
} from './constants';

export const requestDetailApprovalRequests = () => ({
  type: FETCH_DETAIL_APPROVAL_REQUESTS,
});

export const requestDetailApprovalRequestsSuccess = approvalRequests => ({
  type: FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS,
  approvalRequests,
});

export const requestDetailApprovalRequestsFailure = error => ({
  type: FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE,
  error,
});

export const fetchApprovalRequests = () => async (dispatch, getState) => {
  dispatch(requestDetailApprovalRequests());
  const {
    loginReducer: { user: { DefaultEmployeeDetailID } },
  } = getState();
  try {
    const config = {
      url: '/kjarni/api/v2/EmployeeDetailApprovalRequests',
      method: 'GET',
      params: {
        $filter: `EmployeeDetailID eq ${DefaultEmployeeDetailID}`,
      }
    };
    const approvals = get(await custom(config), 'data.value', []);
    const ordered = orderBy(approvals, ['EmployeeDetailApprovalRequestID'], ['desc']);
    dispatch(requestDetailApprovalRequestsSuccess(ordered));
  } catch (error) {
    dispatch(requestDetailApprovalRequestsFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/sites/approvalRequests/actions.js